// src/app/shared/resolvers/hunt.resolver.ts
import { Injectable, inject } from '@angular/core'
import { toObservable } from '@angular/core/rxjs-interop'
import { Resolve, ActivatedRouteSnapshot } from '@angular/router'
import { Observable } from 'rxjs'
import { filter, take, map } from 'rxjs/operators'

import { SessionService } from '../services/session.service'

@Injectable({ providedIn: 'root' })
export class HuntResolver implements Resolve<true> {
  private readonly session = inject(SessionService)
  private readonly activeHunt$ = toObservable(this.session.activeHunt)

  resolve(route: ActivatedRouteSnapshot): Observable<true> {
    const id = route.paramMap.get('id')

    if (!id) {
      throw new Error('HuntResolver: missing `id` param')
    }

    // trigger our SessionService to load (in-memory, API)
    this.session.loadHunt(id)

    // wait until session.activeHunt() is non-null, then emit `true`
    return this.activeHunt$.pipe(
      filter((h) => h !== null),
      take(1),
      map(() => true),
    )
  }
}
